// extracted by mini-css-extract-plugin
module.exports = {"select":"select-action_select__2wW2C"};